<template>
    <div class="pt100 pb100 fs20">
        <h3 class="flex aic jcc">{{title}}</h3>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "nodata-for-detail",
        props: {
            title: {
                type: String,
                default: ''
            },
        },
    }
</script>

<style scoped>

</style>
